import { defineComponent as _defineComponent } from 'vue'
import { usePrimeCompletePopupStore } from '@/stores/primeCompletePopup'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrimeCompletePopup',
  setup(__props) {

/**
 * ヤギプライム決済完了 UI。開閉は Pinia `usePrimeCompletePopupStore`。
 */
const store = usePrimeCompletePopupStore()

return { __sfc: true,store }
}

})